import { Component, Input, input, OnInit } from '@angular/core';
import { SharedService } from '../../shared.service';
import { SharedConstant } from '../../constants/sharedConstants';

@Component({
  selector: 'ems-service-error',
  templateUrl: './service-error.component.html'
})
export class ServiceErrorComponent implements OnInit {
  @Input() inActiveHistoricalView: boolean;
  sharedConst = SharedConstant;
  warningClose = true;

  constructor(public sharedService: SharedService) {
  }
  ngOnInit(): void {
    this.sharedService.showHistoricalView.subscribe((res) =>{
      if(res){
        this.inActiveHistoricalView = true;
      } else if(localStorage.getItem('inactiveClientSelection') === 'true'){
         this.inActiveHistoricalView = true;
      } else{
         this.inActiveHistoricalView = false;
      }
    });
  }
}
